export const googlePlacesFields = [
  'street',
  'streetNumber',
  'neighborhood',
  'city',
  'state',
  'postcode',
  'country',
] as string[]
